<template>
	<div class="apiTokenList">
		<div v-if="!tokens || !tokens.length" class="noTokens">{{emptyText}}</div>
		<div v-for="t in tokens" :key="t.Id" class="apiTokenRecord">
			<div class="apiTokenTitlebar">
				<div class="apiTokenName">{{t.Name}}</div>
				<input type="button" value="revoke" @click="$emit('revoke', t)" :disabled="disabled" :aria-label="'revoke API token ' + t.Name" />
			</div>
			<div class="apiTokenHint">Token: tdsmcp_…{{t.Hint}}</div>
			<div>Permissions: {{permissionText(t.Permissions)}}</div>
			<div>Created {{timeText(t.Created)}}<span v-if="t.CreatedFromIp"> from {{t.CreatedFromIp}}</span></div>
			<div>Last used {{timeText(t.LastUsed)}}<span v-if="t.LastUsed > 0 && t.LastUsedIp"> from {{t.LastUsedIp}}</span></div>
		</div>
	</div>
</template>

<script>
	import { GetFuzzyTime } from 'appRoot/scripts/Util';
	import { ApiTokenPermissionInfo } from 'appRoot/api/UserManageData';

	export default {
		props:
		{
			/**
			 * ApiTokenInfo objects from the server: Id, UserId, Name, Hint, Permissions, Created, CreatedFromIp, LastUsed, LastUsedIp.
			 */
			tokens: {
				type: Array,
				default: () => []
			},
			disabled: {
				type: Boolean,
				default: false
			},
			emptyText: {
				type: String,
				default: "There are no MCP API tokens."
			}
		},
		emits: ['revoke'],
		methods:
		{
			permissionText(permissions)
			{
				if (!permissions || !permissions.length)
					return "none";
				return permissions.map(p => ApiTokenPermissionInfo[p] ? ApiTokenPermissionInfo[p].label : p).join(", ");
			},
			timeText(time)
			{
				if (!time || time <= 0)
					return "never";
				return GetFuzzyTime(Date.now() - time) + " ago (" + new Date(time).toLocaleString() + ")";
			}
		}
	}
</script>

<style scoped>
	.apiTokenRecord
	{
		border: 1px solid #666666;
		border-radius: 5px;
		padding: 4px 8px;
		margin-bottom: 0.5em;
		max-width: 600px;
	}

	.apiTokenTitlebar
	{
		display: flex;
		align-items: center;
		gap: 4px;
		margin-bottom: 2px;
	}

	.apiTokenName
	{
		flex: 1 1 auto;
		font-weight: bold;
		word-break: break-word;
	}

	.apiTokenHint
	{
		font-family: Consolas, monospace;
	}

	.noTokens
	{
		margin-bottom: 0.5em;
	}
</style>
